import { MeasureConfig } from '../types';

/**
 * Resolves colors for all measures based on their configuration and the selected palette.
 * 
 * @param measures List of measures
 * @param palette Array of hex color strings
 * @returns Map of measure ID to resolved hex color
 */
export function resolveSeriesColors(
    measures: MeasureConfig[],
    palette: string[]
): Map<string, string> {
    const colorMap = new Map<string, string>();

    measures.forEach((measure, index) => {
        if (measure.colorMode === 'custom' && measure.color) {
            colorMap.set(measure.id, measure.color);
        } else {
            // Assign from palette based on index to ensure stability
            // This prevents colors from shifting when other measures change mode
            colorMap.set(measure.id, palette[index % palette.length]);
        }
    });

    return colorMap;
}
